import { Component } from "react";
import "./SimilarProducts.css";
import { SmallProduct } from "../smallproduct/SmallProduct";
import axios from "axios";
import { translateUI } from "../../util/dataTranslation";

export class SimilarProducts extends Component {
  constructor() {
    super();
    this.state = {
      similar_products_arr: [],
	  limit: 50,
      loading: true
    };
  }

  componentDidMount() {
    this.loadSimilarProducts(this.props);
  }

  loadSimilarProducts = (nextProps) => {
    if (nextProps.categoryId && nextProps.productName) {
      var productNameSubStr = nextProps.productName.split(" ", 3);
      var limit = nextProps.doLimit ? nextProps.doLimit : 24;

      this.setState({
        similar_products_arr: [],
        limit: nextProps.doLimit ? nextProps.doLimit : 50,
        loading: true
      });

      var mainThis = this;
      axios
        .post(window.ajaxLink + "products/getSimilarProducts", {
          category_id: nextProps.categoryId,
          search_query: productNameSubStr,
          product_id: nextProps.productId,
          limit: limit,
        })
        .then((res) => {
          mainThis.setState({
            similar_products_arr: res["data"]["responseData"]["similarProductsList"],
			limit: nextProps.doLimit ? nextProps.doLimit : 50,
            loading: false
          });
        })
        .catch((err) => {
          mainThis.setState({ loading: false });
        });
    }
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    this.loadSimilarProducts(nextProps);
  };

  render() {
    var showLoadingPlaceholder = this.state.loading && this.props.doLimit > 0;

    return (
      <>
        {(showLoadingPlaceholder || this.state.similar_products_arr.length > 0) && (
          <div className="similar_products">
            <h2 className="similar_products_title">{translateUI("Slični proizvodi", this.props.currentLanguage)}</h2>
            <div className={"similar_products_container" + (showLoadingPlaceholder ? " similar_products_container_loading" : "")}>
              {showLoadingPlaceholder &&
                Array.from(Array(this.props.doLimit).keys()).map((i) => (
                  <div className="section_oneitem in_row_5 similar_products_placeholder_item" key={i} aria-hidden="true">
                    <div className="section_oneitem_image"></div>
                    <div className="section_oneitem_text">
                      <div className="section_oneitem_textname">&nbsp;</div>
                      <div className="section_oneitem_textprice">&nbsp;</div>
                    </div>
                    <div className="section_oneitem_ago">&nbsp;</div>
                    <div className="section_oneitem_location">&nbsp;</div>
                  </div>
                ))}
              {showLoadingPlaceholder && (
                <div className="loader_small active similar_products_loader" aria-hidden="true"></div>
              )}
              {!showLoadingPlaceholder && this.state.similar_products_arr.length > 0 &&
                this.state.similar_products_arr.slice(0, this.state.limit).map((oneItem, i) => (
                  <SmallProduct key={i} oneItem={oneItem} similarItem={true} currentLanguage={this.props.currentLanguage} trackingSource="similar_products" />
                ))}
            </div>
          </div>
        )}
      </>
    );
  }
}

export default SimilarProducts;
